export default __webpack_public_path__ + "static/media/NRSCLogo_new1.65c1ae4a.webp";